<div class="flex flex-row">
	<div
		*ngFor="let tab of tabs"
		(click)="selectTab(tab)"
		class="tab"
		[ngClass]="{ active: tab.active, notactive: !tab.active }">
		{{ tab.title }}
	</div>
</div>
<ng-content class="tab-content"></ng-content>
